import literalValidatorsByType from '../../constants/literalValidatorsByType';

const validateIsOneOf = (expectedTypes: string[], propertyValue: unknown): boolean => {
  return expectedTypes.some(expectedType => {
    const validator = literalValidatorsByType[expectedType];
    return validator?.(propertyValue);
  });
};

export default validateIsOneOf;
